import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface IMuiModalProps {
    isOpen: boolean;
    onClose: () => void;
    onOk?: () => void;
    children: React.ReactElement;
    title?: string;
    okText?: string;
    cancelText?: string;
    showActions?: boolean;
    showCloseIcon?: boolean;
    fullWidth?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const MuiModal = ({
    isOpen,
    onClose,
    onOk,
    children,
    title,
    okText = 'Lưu',
    cancelText = 'Đóng',
    showActions = true,
    showCloseIcon = true,
    fullWidth = true,
    maxWidth = 'xl'
}: IMuiModalProps) => {
    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth={fullWidth} maxWidth={maxWidth}>
            {title && (
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    <Typography variant="h6">{title}</Typography>
                    {showCloseIcon && (
                        <IconButton
                            aria-label="close"
                            onClick={onClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500]
                            }}>
                            <CloseIcon />
                        </IconButton>
                    )}
                </DialogTitle>
            )}

            <DialogContent dividers>{children}</DialogContent>

            {/* {showActions && (
                <DialogActions>
                    <Button onClick={onClose} color="secondary" variant="outlined">
                        {cancelText}
                    </Button>
                    {onOk && (
                        <Button onClick={onOk} variant="contained" color="primary">
                            {okText}
                        </Button>
                    )}
                </DialogActions>
            )} */}
        </Dialog>
    );
};

export default MuiModal;
